export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-wireframes-b7af116447e65c8996824443cf3f50a0.png";